import { Koi } from '@ksyos/koi';
import { getTextAreaStringSchema } from './getTextAreaStringSchema';

export function getTextAreaConditionalSchema<T extends object>(
    fieldKeyForCondition: keyof T & string,
    allowNull: boolean = false
) {
    return Koi.when(fieldKeyForCondition, {
        is: true,
        otherwise: Koi.valid(null),
        then: getTextAreaStringSchema(allowNull),
    });
}
